import { render, staticRenderFns } from "./AnimationTopics.vue?vue&type=template&id=08b3bf7e&"
import script from "./AnimationTopics.vue?vue&type=script&lang=js&"
export * from "./AnimationTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports